import React from "react";
import styled, {css} from "styled-components";


const InputDeadline = ({
                           value,
                           handleChange,
                           name = "deadline",
                           label = 'Échéance'
                       }) => {

    return (
        <Container $mode={label === 'Échéance'}>
            <Label>{label} :</Label>
            <InputContainer>
                <input
                    name={name}
                    type="date"
                    onChange={handleChange}
                    value={value}
                />
            </InputContainer>
        </Container>


    )
}

const Container = styled.div`
  display: flex;

  gap: 0.5em;
  padding: 0.5em;
  border-radius: 10px;
  align-items: center;

  label {
    font-weight: 700;
  }

  ${(props) => {
    switch (props.$mode) {
      case true:
        return css`
          flex-direction: row;
        `;
      default:
        return css`
          flex-direction: column;
          gap: 0.5rem;
        `;
    }
  }}
`
const Label = styled.label`
  flex-grow: 0;
`
const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-grow: 1;

  label > input {
    opacity: 0;
    position: absolute;
  }

  label {
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      color: white;
      text-align: center;
      font-size: 0.9em;
    }
  }
`

export default InputDeadline;